{
    "Accessibility menu": "Toegankelijkheidsmenu",
    "Close": "Sluiten",
    "Content adjustments": "Inhoudsaanpassingen",
    "Navigation adjustments": "Navigatieaanpassingen",
    "Text Align": "Tekstuitlijning",
    "Align Left": "Links uitlijnen",
    "Align Center": "Centreren",
    "Align Right": "Rechts uitlijnen",
    "Adjust Font Size": "Lettergrootte aanpassen",
    "Highlight Title": "Titel markeren",
    "Highlight Links": "Links markeren",
    "Readable Font": "Leesbaar lettertype",
    "Colour adjustments": "Kleuraanpassingen",
    "Dark Contrast": "Donker contrast",
    "Light Contrast": "Licht contrast",
    "High Contrast": "Hoog contrast",
    "High Saturation": "Hoge verzadiging",
    "Low Saturation": "Lage verzadiging",
    "Monochrome": "Monochroom",
    "Tools": "Hulpmiddelen",
    "Reading Guide": "Leeslijn",
    "Big Cursor": "Grote cursor",
    "Increase Font Size": "Lettergrootte vergroten",
    "Decrease Font Size": "Lettergrootte verkleinen",
    "Letter Spacing": "Letterafstand",
    "Line Height": "Regelhoogte",
    "Font Weight": "Letterdikte",
    "Dyslexia Font": "Dyslexie-lettertype",
    "Language": "Taal",
    "Accessibility widget": "Toegankelijkheidsmenu openen",
    "Accessibility Profiles": "Toegankelijkheidsprofielen",
    "Cognitive Disability": "Cognitieve beperking",
    "Seizure Safe": "Epilepsieveilig",
    "Accessibility statement": "Toegankelijkheidsverklaring",
    "ADHD": "ADHD",
    "Low Vision": "Slechtziend",
    "Pause Animations": "Animaties pauzeren",
    "Animation paused": "Animatie gepauzeerd",
    "Reset all settings": "Instellingen resetten",
    "Shortcut:": "Sneltoets:",
    "Epilepsy Safe Mode": "Epilepsieveilige modus",
    "Mute sounds": "Geluiden dempen",
    "Page read": "Pagina voorlezen",
    "Page read controls": "Voorleesbediening",
    "Pause": "Pauzeren",
    "Resume": "Hervatten",
    "Stop": "Stoppen",
    "Settings": "Instellingen",
    "Speed": "Snelheid",
    "Voice": "Stem",
    "Close accessibility menu": "Toegankelijkheidsmenu sluiten",
    "Back to accessibility menu": "Terug naar toegankelijkheidsmenu",
    "Search languages": "Talen zoeken",
    "Selected language": "Geselecteerde taal",
    "View accessibility statement (opens in new window)": "Toegankelijkheidsverklaring bekijken (opent in nieuw venster)",
    "Visit CookieYes website (opens in new window)": "CookieYes-website bezoeken (opent in nieuw venster)",
    "Reset all accessibility settings to default": "Alle toegankelijkheidsinstellingen herstellen"
}
